import Choices from 'choices.js'

window.addEventListener('load', () => {
  // const selectInputs = document.querySelectorAll(`[data-item="select-input"]`)

  // if (selectInputs.length > 0) {
  //   selectInputs.forEach((selectInput) => {
  //     const choicesInput = new Choices(selectInput, {
  //       allowHTML: true,
  //       placeholder: true,
  //       placeholderValue: 'Type and add multiple options',
  //     })
  //   })
  // }

  const selects = document.querySelectorAll(`[data-item="terms-select"]`)
  if (selects.length > 0) {
    selects.forEach((select) => {
      // const choices = new Choices(select, {
      //   allowHTML: true,
      // })
      window.choices = new Choices(select,
        //   {
        //   shouldSort: false,
        //   callbackOnCreateTemplates: function (template) {
        //     return {
        //       item: ({ classNames }: any, data: any) => {
        //         return template(`
        //           <div data-plan-option-seleted>
        //             ${data.label}
        //           </div>
        //         `)
        //       },
        //       choice: ({ classNames }: any, data: any) => {
        //         // console.log(data.customProperties.price)
        //         return template(`
        //     <span data-item="term-option" data-url="${data.customProperties.url}" data-price="${data.customProperties.price}" data-value="${data.value}" class="${classNames.item} ${classNames.itemChoice} ${data.disabled
        //             ? classNames.itemDisabled
        //             : classNames.itemSelectable
        //           }">
        //         ${data.label}
        //       </span>
        //     `)
        //       },
        //     }
        //   },
        // }
      )
      select.addEventListener(
        'choice',
        function (event) {
          console.log(event.detail.choice.customProperties);
          const priceWrapper = document.querySelector(`[data-item="term-price"]`)
          const courseBtn = document.querySelector(`[data-item="term-url"]`)

          if (event.detail.choice.customProperties) {
            if (priceWrapper) {
              priceWrapper.textContent = event.detail.choice.customProperties.price
            }
            if (courseBtn) {
              courseBtn.setAttribute('href', event.detail.choice.customProperties.url)
            }
          }

        },
        false,
      );
    })
  }

  // const termsOptions = document.querySelectorAll(`[data-item="term-option"]`)

  // if (termsOptions.length > 0) {
  //   termsOptions.forEach((option) => {
  //     option.addEventListener('click', (e) => {
  //       console.log('rr')
  //       const price = option.getAttribute('data-price')
  //       const value = option.getAttribute('data-value')
  //       const priceWrapper = document.querySelector(`[data-item="term-price"]`)

  //       if (price && priceWrapper) {
  //         priceWrapper.textContent = option.getAttribute('data-price')
  //       }

  //       window.choices.hideDropdown();
  //       // window.choices.setChoiceByValue(value);

  //     })
  //   })
  // }


  // const selectsMultiple = document.querySelectorAll(
  //   `[data-item="select-multiple"]`,
  // )
  // if (selectsMultiple.length > 0) {
  //   selectsMultiple.forEach((selectMultiple) => {
  //     const choicesMultiple = new Choices(selectMultiple, {
  //       allowHTML: true,
  //       placeholderValue: 'Choose a options',
  //     })
  //   })
  // }
})
